/**
 * @class ReelsFrameController
 * @description Controller for managing ReelsFrame - switching between MainGame and FreeGame frames
 */
export class ReelsFrameController {
    /**
     * @param {Object} reelsFrame - ReelsFrame container from layout
     */
    constructor(reelsFrames) {
        this.framesContainers = reelsFrames;
        this.framesByName = {};

        if (this.framesContainers) {
            this.framesContainers.forEach(frame => {
                frame.children.forEach(child => {
                    if (child.name) {
                        if (!this.framesByName[child.name]) {
                            this.framesByName[child.name] = [];
                        }
                        this.framesByName[child.name].push(child);
                    }
                });
            });
        }

        this.showFrame("MainGame");
    }

    /**
     * @description Show frame by name, hide all others
     * @param {string} name - Frame name ("MainGame" or "FreeGame")
     */
    showFrame(name) {
        const frames = this.framesByName[name];

        Object.keys(this.framesByName).forEach(frameName => {
                this.framesByName[frameName].forEach(frame => {
                    frame.visible = frameName === name;
                });
        });
    }
}

